import * as React from 'react';
import AppInputError from './input-error';

export interface FilterInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: string;
  position?: 'start' | 'end';
  children?: React.ReactElement;
  endIcon?: React.ReactElement | null;
  disabled?: boolean;
  label?: string;
  required?: boolean;
  errorMessage?: string;
  filter?: (value: string) => boolean; // Filter function to validate input
  onSearch?: (value: string) => void; // Callback for search action
}

const FilterInput = React.forwardRef<HTMLInputElement, FilterInputProps>(
  (props: FilterInputProps) => {
    const [pos, setPos] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');

    const IconPlacement = () => {
      return props.icon === 'envelope' ? (
        <div
          className={`absolute px-4 ${props.position === 'end' ? ` right-0 ` : ''}`}
        >
          {props.children}
        </div>
      ) : props.icon === 'password' ? (
        <div
          className={`absolute px-4 ${props.position === 'end' ? ` right-0 ` : ''}`}
        >
          {props.children}
        </div>
      ) : null;
    };

    React.useEffect(() => {
      switch (props.position) {
        case 'start':
          return setPos('pl-0');
        case 'end':
          return setPos('pr-0');
        default:
          return props.icon ? setPos('pl-0') : setPos('');
      }
    }, [props.position, props.icon]);

    const handleBlur = () => {
      if (props.filter && !props.filter(inputValue)) {
        console.error('Input does not match the filter criteria.');
        return;
      }
      if (props.onSearch) {
        props.onSearch(inputValue); 
      }
    };

    return (
      <div className=''>
        <div 
          className={`flex justify-start relative items-center  rounded-xl border border-gray-300 px-4 py-2.5 ${props.errorMessage ? 'border-red-500 bg-red-50' : ''}`}
        >
          {!props.position && props.icon && <IconPlacement />}
          {props.position === 'start' && props.icon && <IconPlacement />}
          <input
            type={props.type}
            className={`flex w-full bg-transparent hover:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 text-sm ${pos}`}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)} 
            onBlur={handleBlur} 
            {...props}
          />
          {props.position === 'end' && <IconPlacement />}
          {props.endIcon}
        </div>
        {props.errorMessage && <AppInputError text={props.errorMessage} />}
      </div>
    );
  },
);

FilterInput.displayName = 'FilterInput';

export default FilterInput;
